/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Animated(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.87808 3.12499C9.54296 2.3992 10.6666 2.33759 11.4064 2.9873L14.8878 6.04687C15.2407 6.35697 15.4793 6.77091 15.5753 7.22265L15.6271 7.26855L15.589 7.30956C15.6092 7.42828 15.6232 7.54869 15.6232 7.67089V9.9287C15.6232 10.0993 15.7612 10.238 15.9318 10.2383H19.0832V11.7383H15.9318C14.9328 11.738 14.1232 10.9278 14.1232 9.9287V8.95214L11.131 12.3037L12.4181 13.4756H12.4191C13.1488 14.1398 13.211 15.2674 12.5597 16.0088H12.5587L10.1066 18.8252L9.61343 19.3916L8.48257 18.4062L8.97574 17.8408L11.4308 15.0205L11.4328 15.0185C11.5441 14.8918 11.5341 14.6985 11.4093 14.585L9.95425 13.2607L9.0148 12.4219L9.02164 12.4131L8.52066 11.957V11.956C7.64232 11.1561 7.57406 9.79827 8.36734 8.91405L8.36636 8.91308L11.673 5.21874L10.4162 4.11425C10.2897 4.00338 10.0971 4.01375 9.98355 4.13769L9.9816 4.14062L8.11539 6.16503L7.6066 6.71581L6.50406 5.69921L7.01187 5.14843L8.87808 3.12402V3.12499ZM2.1564 11.2598L4.87027 13.5957L4.87613 13.6006C5.0029 13.7118 5.19521 13.7009 5.30875 13.5762C5.31253 13.572 5.31659 13.5675 5.32046 13.5635L6.80972 12.0029L7.3273 11.4609L8.41226 12.4961L7.89468 13.0391L6.4064 14.5996L6.40445 14.5976C5.74039 15.3134 4.62876 15.3745 3.89175 14.7324L1.17789 12.3975L0.609527 11.9082L1.58804 10.7705L2.1564 11.2598ZM9.48453 9.91308L9.48355 9.91405L9.40445 10.0225C9.24919 10.2869 9.295 10.6331 9.53043 10.8476L10.0207 11.2939L13.7873 7.07616L12.8 6.208L9.48453 9.91308ZM16.2502 0.832999C17.4007 0.833 18.3332 1.76639 18.3332 2.91698C18.333 4.06743 17.4006 4.99999 16.2502 4.99999C15.0997 4.99999 14.1673 4.06743 14.1671 2.91698C14.1671 1.76639 15.0996 0.832999 16.2502 0.832999Z"
        fill="#35424F"
      />
    </svg>
  )
}

Animated.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Animated
